import React from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../primitives/SMLButton';
import styles from './SMLUpgradePromptActions.module.scss';

interface SMLUpgradePromptActionsProps {
  /** `undefined` renders no checkout button at all — design o's member states (ruling 8) replace
   * it with `TeamOwnerNote` instead of a disabled button. */
  primaryLabel?: string;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  /** The ghost button: "Compare all plans". Design b2 has none. */
  secondaryLabel?: string;
  onSecondary?: () => void;
  /** The quiet link at the right end: "Not now", "Wait for 1 Oct". */
  laterLabel: string;
  onLater: () => void;
}

/** Design b's action row: the checkout button, an optional ghost button, and a quiet "later" link. */
const SMLUpgradePromptActionsComponent: React.FC<SMLUpgradePromptActionsProps> = ({
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  secondaryLabel,
  onSecondary,
  laterLabel,
  onLater,
}) => (
  <div className={styles.actions}>
    {primaryLabel !== undefined && (
      <SMLButton variant="primary" disabled={primaryDisabled} onClick={onPrimary}>
        {primaryLabel}
      </SMLButton>
    )}
    {secondaryLabel !== undefined && <SMLButton onClick={onSecondary}>{secondaryLabel}</SMLButton>}
    <button type="button" className={styles.later} onClick={onLater}>
      {laterLabel}
    </button>
  </div>
);

export const SMLUpgradePromptActions = TypedMemo(SMLUpgradePromptActionsComponent);
